// Shared type system for template IDs and section management.
// Usable from both Convex backend functions and frontend React components.

export const TEMPLATE_IDS = [
  "narrative",
  "watercolor",
  "typographic",
  "editorial",
  "whimsical",
  "traditional",
] as const;
export type TemplateId = (typeof TEMPLATE_IDS)[number];

export const TEMPLATE_SECTION_IDS = [
  "hero",
  "details",
  "countdown",
  "gallery",
  "message",
  "rsvp",
  "calendar",
  "footer",
] as const;

export type TemplateSectionId = (typeof TEMPLATE_SECTION_IDS)[number];

export const TEMPLATE_SECTION_LABELS: Record<TemplateSectionId, string> = {
  calendar: "Calendario",
  countdown: "Cuenta Regresiva",
  details: "Ceremonia",
  footer: "Pie de Página",
  gallery: "Galería",
  hero: "Portada",
  message: "Mensaje",
  rsvp: "Confirmar asistencia",
};

export const FOOTER_SECTION_ID: TemplateSectionId = "footer";
